module.exports = __webpack_public_path__ + "static/media/Vector.fc45f493.svg";